import React from "react";

import { cn } from "../cn";

export type InputProps = React.ComponentProps<"input"> & {
  error?: boolean;
};
export function Input({ className, error, type = "text", ...props }: InputProps) {
  return (
    <input
      data-slot="input"
      type={type}
      aria-invalid={error || undefined}
      className={cn(
        "tw-flex tw-h-9 tw-w-full tw-min-w-0 tw-appearance-none tw-rounded-md tw-border tw-border-solid tw-bg-input",
        "tw-px-3 tw-py-1 tw-font-sans tw-text-sm tw-text-foreground tw-shadow-xs tw-outline-none tw-transition-[color,box-shadow]",
        "placeholder:tw-text-muted-foreground focus-visible:tw-ring disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
        error ? "tw-border-destructive-border focus-visible:tw-ring-ring-error" : "tw-border-border focus-visible:tw-border-ring focus-visible:tw-ring-ring/50",
        className,
      )}
      {...props}
    />
  );
}
